import { getFirebaseDb } from '@/services/firebaseService'
import { doc, updateDoc, increment } from 'firebase/firestore'

/**
 * 회사 문서의 버전 정보를 업데이트합니다.
 * @param companyId 회사 ID
 * @param versionKey 버전 키 (예: 'orderPenVersion', 'orderPenArchiveVersion')
 * @param incrementAmount 증가량 (기본: 0.01 - 소수점 변경, 1.0 - 정수 변경)
 */
export async function updateCompanyVersion(
  companyId: string,
  versionKey: string,
  incrementAmount = 0.01
): Promise<void> {
  if (!companyId || !versionKey) return

  try {
    const db = getFirebaseDb()
    const companyRef = doc(db, 'v2_companies', companyId)

    // versionInfo.{versionKey} 형태로 중첩된 필드 업데이트
    const updateField = `versionInfo.${versionKey}`

    await updateDoc(companyRef, {
      [updateField]: increment(incrementAmount),
    })

    console.log(`✅ ${versionKey} 버전 업데이트: +${incrementAmount}`)
  } catch (error) {
    console.error(`❌ ${versionKey} 버전 업데이트 실패:`, error)
    throw error
  }
}

/**
 * OrderPen 관련 작업에 따른 버전 업데이트
 */
export const OrderPenVersionUpdater = {
  // 주문 생성/수정 시 (소수점 증가)
  async onCreateOrUpdate(companyId: string): Promise<void> {
    await updateCompanyVersion(companyId, 'orderPenVersion', 0.01)
  },

  // 주문 삭제 시 (정수 증가)
  async onDelete(companyId: string): Promise<void> {
    await updateCompanyVersion(companyId, 'orderPenVersion', 1.0)
  },

  // 아카이브 생성/수정 시 (소수점 증가)
  async onArchiveUpdate(companyId: string): Promise<void> {
    await updateCompanyVersion(companyId, 'orderPenArchiveVersion', 0.01)
  },

  // 아카이브 삭제 시 (정수 증가)
  async onArchiveDelete(companyId: string): Promise<void> {
    await updateCompanyVersion(companyId, 'orderPenArchiveVersion', 1.0)
  },

  // 아카이브 작업 시 (양쪽 모두 업데이트)
  async onArchiveOperation(companyId: string): Promise<void> {
    // 활성 주문이 아카이브로 이동 = 활성 삭제 + 아카이브 생성
    await Promise.all([
      updateCompanyVersion(companyId, 'orderPenVersion', 1.0), // 활성에서 삭제
      updateCompanyVersion(companyId, 'orderPenArchiveVersion', 0.01), // 아카이브에 추가
    ])
  },
}
